import React from "react";

type TeamsIconProps = {
	size?: number;
};

// Microsoft Teams logo from the PY-12434 Figma designs (gradient ids namespaced to avoid collisions).
export const TeamsIcon = ({ size }: TeamsIconProps): React.ReactElement => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width={size ?? 48} height={size ?? 48} viewBox="0 0 45 48" fill="none">
			<path
				d="M22.5 20.2105H37.5C39.4891 20.2105 41.3968 21.009 42.8033 22.4303C44.2098 23.8517 45 25.7794 45 27.7895V40.421C45 42.4311 44.2098 44.3588 42.8033 45.7802C41.3968 47.2015 39.4891 48 37.5 48C35.5109 48 33.6032 47.2015 32.1967 45.7802C30.7902 44.3588 30 42.4311 30 40.421V27.7895C30 25.7794 29.2098 23.8517 27.8033 22.4303C26.3968 21.009 24.4891 20.2105 22.5 20.2105Z"
				fill="url(#teamsIconPaint0)"
			/>
			<path
				d="M5 25.2632C5 23.2531 5.79018 21.3254 7.1967 19.904C8.60322 18.4827 10.5109 17.6842 12.5 17.6842H22.5C24.4891 17.6842 26.3968 18.4827 27.8033 19.904C29.2098 21.3254 30 23.2531 30 25.2632V40.421C30 42.4311 30.7902 44.3588 32.1967 45.7802C33.6032 47.2015 35.5109 48 37.5 48H17.5C10.5963 48 5 42.3448 5 35.3684V25.2632Z"
				fill="url(#teamsIconPaint1)"
			/>
			<path
				d="M5 25.2632C5 23.2531 5.79018 21.3254 7.1967 19.904C8.60322 18.4827 10.5109 17.6842 12.5 17.6842H22.5C24.4891 17.6842 26.3968 18.4827 27.8033 19.904C29.2098 21.3254 30 23.2531 30 25.2632V40.421C30 42.4311 30.7902 44.3588 32.1967 45.7802C33.6032 47.2015 35.5109 48 37.5 48H17.5C10.5963 48 5 42.3448 5 35.3684V25.2632Z"
				fill="url(#teamsIconPaint2)"
				fillOpacity="0.7"
			/>
			<path
				d="M5 25.2632C5 23.2531 5.79018 21.3254 7.1967 19.904C8.60322 18.4827 10.5109 17.6842 12.5 17.6842H22.5C24.4891 17.6842 26.3968 18.4827 27.8033 19.904C29.2098 21.3254 30 23.2531 30 25.2632V40.421C30 42.4311 30.7902 44.3588 32.1967 45.7802C33.6032 47.2015 35.5109 48 37.5 48H17.5C10.5963 48 5 42.3448 5 35.3684V25.2632Z"
				fill="url(#teamsIconPaint3)"
				fillOpacity="0.7"
			/>
			<path
				d="M36.25 17.6842C37.9076 17.6842 39.4973 17.0188 40.6694 15.8343C41.8415 14.6499 42.5 13.0435 42.5 11.3684C42.5 9.69335 41.8415 8.0869 40.6694 6.90246C39.4973 5.71802 37.9076 5.05261 36.25 5.05261C34.5924 5.05261 33.0027 5.71802 31.8306 6.90246C30.6585 8.0869 30 9.69335 30 11.3684C30 13.0435 30.6585 14.6499 31.8306 15.8343C33.0027 17.0188 34.5924 17.6842 36.25 17.6842Z"
				fill="url(#teamsIconPaint4)"
			/>
			<path
				d="M36.25 17.6842C37.9076 17.6842 39.4973 17.0188 40.6694 15.8343C41.8415 14.6499 42.5 13.0435 42.5 11.3684C42.5 9.69335 41.8415 8.0869 40.6694 6.90246C39.4973 5.71802 37.9076 5.05261 36.25 5.05261C34.5924 5.05261 33.0027 5.71802 31.8306 6.90246C30.6585 8.0869 30 9.69335 30 11.3684C30 13.0435 30.6585 14.6499 31.8306 15.8343C33.0027 17.0188 34.5924 17.6842 36.25 17.6842Z"
				fill="url(#teamsIconPaint5)"
				fillOpacity="0.46"
			/>
			<path
				d="M36.25 17.6842C37.9076 17.6842 39.4973 17.0188 40.6694 15.8343C41.8415 14.6499 42.5 13.0435 42.5 11.3684C42.5 9.69335 41.8415 8.0869 40.6694 6.90246C39.4973 5.71802 37.9076 5.05261 36.25 5.05261C34.5924 5.05261 33.0027 5.71802 31.8306 6.90246C30.6585 8.0869 30 9.69335 30 11.3684C30 13.0435 30.6585 14.6499 31.8306 15.8343C33.0027 17.0188 34.5924 17.6842 36.25 17.6842Z"
				fill="url(#teamsIconPaint6)"
				fillOpacity="0.4"
			/>
			<path
				d="M17.5 15.1579C19.4891 15.1579 21.3968 14.3594 22.8033 12.9381C24.2098 11.5167 25 9.58901 25 7.57895C25 5.56889 24.2098 3.64115 22.8033 2.21982C21.3968 0.798494 19.4891 0 17.5 0C15.5109 0 13.6032 0.798494 12.1967 2.21982C10.7902 3.64115 10 5.56889 10 7.57895C10 9.58901 10.7902 11.5167 12.1967 12.9381C13.6032 14.3594 15.5109 15.1579 17.5 15.1579Z"
				fill="url(#teamsIconPaint7)"
			/>
			<path
				d="M17.5 15.1579C19.4891 15.1579 21.3968 14.3594 22.8033 12.9381C24.2098 11.5167 25 9.58901 25 7.57895C25 5.56889 24.2098 3.64115 22.8033 2.21982C21.3968 0.798494 19.4891 0 17.5 0C15.5109 0 13.6032 0.798494 12.1967 2.21982C10.7902 3.64115 10 5.56889 10 7.57895C10 9.58901 10.7902 11.5167 12.1967 12.9381C13.6032 14.3594 15.5109 15.1579 17.5 15.1579Z"
				fill="url(#teamsIconPaint8)"
				fillOpacity="0.6"
			/>
			<path
				d="M17.5 15.1579C19.4891 15.1579 21.3968 14.3594 22.8033 12.9381C24.2098 11.5167 25 9.58901 25 7.57895C25 5.56889 24.2098 3.64115 22.8033 2.21982C21.3968 0.798494 19.4891 0 17.5 0C15.5109 0 13.6032 0.798494 12.1967 2.21982C10.7902 3.64115 10 5.56889 10 7.57895C10 9.58901 10.7902 11.5167 12.1967 12.9381C13.6032 14.3594 15.5109 15.1579 17.5 15.1579Z"
				fill="url(#teamsIconPaint9)"
				fillOpacity="0.5"
			/>
			<path
				d="M15.9375 24H4.0625C1.81884 24 0 25.838 0 28.1053V40.1053C0 42.3725 1.81884 44.2105 4.0625 44.2105H15.9375C18.1812 44.2105 20 42.3725 20 40.1053V28.1053C20 25.838 18.1812 24 15.9375 24Z"
				fill="url(#teamsIconPaint10)"
			/>
			<path
				d="M15.9375 24H4.0625C1.81884 24 0 25.838 0 28.1053V40.1053C0 42.3725 1.81884 44.2105 4.0625 44.2105H15.9375C18.1812 44.2105 20 42.3725 20 40.1053V28.1053C20 25.838 18.1812 24 15.9375 24Z"
				fill="url(#teamsIconPaint11)"
				fillOpacity="0.7"
			/>
			<path
				d="M14.35 30.4484H11.29V39.8792H8.70874V30.4484H5.64999V28.3326H14.35V30.4497V30.4484Z"
				fill="white"
			/>
			<defs>
				<radialGradient
					id="teamsIconPaint0"
					cx="0"
					cy="0"
					r="1"
					gradientUnits="userSpaceOnUse"
					gradientTransform="translate(44.7462 22.9566) scale(16.848 42.0245)"
				>
					<stop stopColor="#A98AFF" />
					<stop offset="0.14" stopColor="#8C75FF" />
					<stop offset="0.565" stopColor="#5F50E2" />
					<stop offset="0.9" stopColor="#3C2CB8" />
				</radialGradient>
				<radialGradient
					id="teamsIconPaint1"
					cx="0"
					cy="0"
					r="1"
					gradientTransform="matrix(15.2344 38.4 -38.4305 15.5692 6.015 15.6632)"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#85C2FF" />
					<stop offset="0.69" stopColor="#7588FF" />
					<stop offset="1" stopColor="#6459FE" />
				</radialGradient>
				<linearGradient
					id="teamsIconPaint2"
					x1="20.7425"
					y1="17.6842"
					x2="20.7425"
					y2="48"
					gradientUnits="userSpaceOnUse"
				>
					<stop offset="0.801" stopColor="#6864F6" stopOpacity="0" />
					<stop offset="1" stopColor="#5149DE" />
				</linearGradient>
				<radialGradient
					id="teamsIconPaint3"
					cx="0"
					cy="0"
					r="1"
					gradientTransform="matrix(-9.5123 22.292 -17.708 -7.71616 29.3754 16.674)"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#BD96FF" />
					<stop offset="0.687" stopColor="#BD96FF" stopOpacity="0" />
				</radialGradient>
				<radialGradient
					id="teamsIconPaint4"
					cx="0"
					cy="0"
					r="1"
					gradientUnits="userSpaceOnUse"
					gradientTransform="translate(36.25 9.56335) rotate(-90) scale(12.6316 15.777)"
				>
					<stop offset="0.268" stopColor="#6868F7" />
					<stop offset="1" stopColor="#3923B1" />
				</radialGradient>
				<radialGradient
					id="teamsIconPaint5"
					cx="0"
					cy="0"
					r="1"
					gradientTransform="matrix(6.8378 5.80859 -8.31396 9.99421 31.0838 8.26609)"
					gradientUnits="userSpaceOnUse"
				>
					<stop offset="0.271" stopColor="#A1D3FF" />
					<stop offset="0.813" stopColor="#A1D3FF" stopOpacity="0" />
				</radialGradient>
				<radialGradient
					id="teamsIconPaint6"
					cx="0"
					cy="0"
					r="1"
					gradientTransform="matrix(7.95012 -7.1473 17.3502 19.7075 41.2279 8.04437)"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#E3ACFD" />
					<stop offset="0.816" stopColor="#9FA2FF" stopOpacity="0" />
				</radialGradient>
				<radialGradient
					id="teamsIconPaint7"
					cx="0"
					cy="0"
					r="1"
					gradientUnits="userSpaceOnUse"
					gradientTransform="translate(17.5 5.41389) rotate(-90) scale(15.1579 18.9325)"
				>
					<stop offset="0.268" stopColor="#8282FF" />
					<stop offset="1" stopColor="#3923B1" />
				</radialGradient>
				<radialGradient
					id="teamsIconPaint8"
					cx="0"
					cy="0"
					r="1"
					gradientTransform="matrix(8.2053 6.97037 -9.9768 11.9929 11.3011 3.85652)"
					gradientUnits="userSpaceOnUse"
				>
					<stop offset="0.271" stopColor="#A1D3FF" />
					<stop offset="0.813" stopColor="#A1D3FF" stopOpacity="0" />
				</radialGradient>
				<radialGradient
					id="teamsIconPaint9"
					cx="0"
					cy="0"
					r="1"
					gradientTransform="matrix(9.54014 -8.57676 20.8203 23.649 23.4735 3.59034)"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#E3ACFD" />
					<stop offset="0.816" stopColor="#9FA2FF" stopOpacity="0" />
				</radialGradient>
				<radialGradient
					id="teamsIconPaint10"
					cx="0"
					cy="0"
					r="1"
					gradientTransform="matrix(20 20.2105 -20 20.2105 -0.000209808 23.9994)"
					gradientUnits="userSpaceOnUse"
				>
					<stop offset="0.047" stopColor="#688EFF" />
					<stop offset="0.947" stopColor="#230F94" />
				</radialGradient>
				<radialGradient
					id="teamsIconPaint11"
					cx="0"
					cy="0"
					r="1"
					gradientUnits="userSpaceOnUse"
					gradientTransform="translate(10 36.1263) rotate(90) scale(14.1474 16.3378)"
				>
					<stop offset="0.571" stopColor="#6965F6" stopOpacity="0" />
					<stop offset="1" stopColor="#8F8FFF" />
				</radialGradient>
			</defs>
		</svg>
	);
};
